// Cobrança dos canais (Adnéia, 04/11/2026; processo em atendimento/processos/cobranca-dos-canais.md).
// A mesma conta do backend (utils/cobranca_canais.py): dias úteis do dia em que o cliente acionou o
// canal até a abertura do atendimento no ELO, sem sábado, domingo e os feriados que a rota
// /api/feriados devolve. Mais de 5: o canal demorou para nos acionar.

export const LIMITE_DIAS_UTEIS = 5;

// No ZAP/E-mail e no Reclame aqui o cliente fala direto com a gente: não há canal para cobrar.
const CANAIS_FORA = ['zap/e-mail', 'reclame aqui'];

export const canalEntra = (canal) => {
  const nome = (canal || '').trim().toLowerCase();
  return !!nome && !CANAIS_FORA.includes(nome);
};

const DIA_ISO = /^(\d{4})-(\d{2})-(\d{2})$/;
const BRT_MS = 3 * 60 * 60 * 1000;

// 'AAAA-MM-DD' de Brasília: o dia curto fica como está; data com hora é convertida (UTC-3).
export const diaBrt = (valor) => {
  if (!valor) return null;
  if (typeof valor === 'string' && DIA_ISO.test(valor)) return valor;
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getTime() - BRT_MS).toISOString().slice(0, 10);
};

export const hojeBrt = () => diaBrt(new Date());

const paraData = (iso) => {
  const m = DIA_ISO.exec(iso || '');
  return m ? new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]))) : null;
};

// Dias úteis depois de `inicio` até `fim`, contando `fim`. Mesmo dia, ou `fim` antes: 0.
export const diasUteis = (inicio, fim, feriados) => {
  const ini = paraData(inicio);
  const ate = paraData(fim);
  if (!ini || !ate) return null;
  const folga = new Set(feriados || []);
  let n = 0;
  const d = new Date(ini.getTime());
  while (d < ate) {
    d.setUTCDate(d.getUTCDate() + 1);
    const dia = d.getUTCDay();
    if (dia !== 0 && dia !== 6 && !folga.has(d.toISOString().slice(0, 10))) n += 1;
  }
  return n;
};

// "04/11 15h20" em Brasília, para o quem e quando da marca.
export const quandoBrt = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const b = new Date(d.getTime() - BRT_MS).toISOString();
  return `${b.slice(8, 10)}/${b.slice(5, 7)} ${b.slice(11, 13)}h${b.slice(14, 16)}`;
};

// A coluna "Canal > 5 dias úteis" do Ranking por Canal (aba Volume), a partir do que a rota manda:
// {fora, com_data, acima, sem_data, pct}. Sem resumo: "?"; canal fora: "—".
export const textoColunaDemora = (c) => {
  if (!c) return { principal: '?', detalhe: 'sem dado' };
  if (c.fora) return { principal: '—', detalhe: 'não entra' };
  const semData = c.sem_data ? `${c.sem_data} sem data` : '';
  if (c.pct === null || c.pct === undefined) return { principal: '?', detalhe: semData || 'sem data' };
  const base = `${c.acima} de ${c.com_data}`;
  return { principal: `${String(c.pct).replace('.', ',')}%`, detalhe: semData ? `${base} · ${semData}` : base };
};
